<template>
  <div
    class="customer-service-btn"
    @click="handleClick"
  >
    <img
      class="customer-service-img"
      src="@/assets/img/chargingVoucher/icon-customer-service.png"
    >
    <div
      v-if="$parent.$parent.showBottomNavBar"
      class="h-bottom-nav"
    />
  </div>
</template>

<script>
export default {
  name: 'CustomerServiceBtn',
  data() {
    return {};
  },
  methods: {
    handleClick() {
      if (this.$browserEnv == 0) {
        wx.miniProgram.navigateTo({
          url: '/pages/extend/customer-service'
        });
      } else {
        this.$toast('功能开发中，敬请期待');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-service-btn {
  position: fixed;
  right: 0;
  bottom: 0;

  .customer-service-img {
    width: 150px;
    height: 150px;
    object-fit: contain;
    margin-bottom: 48px;
  }
}
.h-bottom-nav {
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
}
</style>
